export const InfoIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#a)">
      <circle cx="12" cy="12" r="9.5" stroke="#838BA4" />
      <path
        stroke="#838BA4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12.01 16v-4m0-4H12"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
